import { render, staticRenderFns } from "./ClientHealthCheck.vue?vue&type=template&id=0fa152a0&scoped=true&"
import script from "./ClientHealthCheck.vue?vue&type=script&lang=js&"
export * from "./ClientHealthCheck.vue?vue&type=script&lang=js&"
import style0 from "./ClientHealthCheck.vue?vue&type=style&index=0&id=0fa152a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa152a0",
  null
  
)

export default component.exports